function t() {
  const a = navigator.language;
  return r(a) ? n(a) : a;
}
const r = (a) => a.length === 2;
function n(a) {
  let e = "";
  switch (a) {
    case "zh":
      e = "zh-CN";
      break;
    case "en":
      e = "en-US";
      break;
    case "de":
      e = "de-DE";
      break;
    case "ja":
      e = "ja-JP";
      break;
    case "it":
      e = "it-IT";
      break;
    case "nl":
      e = "nl-NL";
      break;
    case "sp":
      e = "sp-SP";
      break;
    case "el":
      e = "el-GR";
      break;
    case "fr":
      e = "fr-FR";
      break;
    case "pl":
      e = "pl-PL";
      break;
    case "cs":
      e = "cs-CZ";
      break;
    default:
      e = "en-US";
      break;
  }
  return e;
}
function s(a, e) {
  return e.includes(a) ? a : "en-US";
}
function c(a) {
  return a.substring(0, 2).toLowerCase();
}
export {
  s as checkLanguage,
  t as getBrowserLanguage,
  n as getLongCode,
  c as getShortCode,
  r as isShortCode
};
